import reset from './reset.js';
//import variables from 'variables.js';
import mixins from './mixins.js';

export default {
  ...reset,
  ...mixins,
  '@global': {
    body: {
      margin: '0px',
      button: {
        '$:focus': {
          outline: '0'
        }
      }
    }
  },
  clearfix: {
    '&::after': {
      display: 'block',
      content: "''",
      clear: 'both'
    }
  }
};
